import MenuCM from "components/shared/menu";
import Box from "@mui/material/Box";
import ContactCM from "components/contactus";
import { StyledIcondiv, StatusMain } from "./Payment.style";
import { Container } from "@mui/material";
import FooterCM from "components/shared/footer";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import {Helmet} from "react-helmet";

export default function PaymentStatus() {
  return (
    <>
      <Box
        style={{
          marginBottom: "50px",
          marginTop: "70px",
        }}
      >
        <>
          <Helmet>
            <title>سفارش ناموفق - مبلمان ویول</title>
            <meta name="product_id" content={""} />
            <meta name="product_name" content={""} />
            <meta name="product_price" content={""} />
            <meta name="product_old_price" content={""} />
            <meta name="availability" content={""} />
            <meta property="og:image" content={""} />
          </Helmet>
          <MenuCM Background pageTitle="وضعیت پرداخت" />
          <Container>
            <StatusMain>
              <StyledIcondiv>
                <HighlightOffIcon style={{ color: "red" }} />
              </StyledIcondiv>
              <p>پرداخت با خطا مواجه شد</p>
              <p>
                در صورت کسر وجه از حساب تا 72 ساعت آینده مبلغ به حساب شما باز
                میگردد
              </p>
            </StatusMain>
          </Container>
          <ContactCM All />
          <FooterCM />
        </>
      </Box>
    </>
  );
}
